/* KLB: keeps <klb-freeship> bars in sync with the cart on every cart change. */
if (!customElements.get('klb-freeship')) {
  customElements.define(
    'klb-freeship',
    class KlbFreeship extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.klb-fs__text');
        this.fill = this.querySelector('.klb-fs__fill');
        this.track = this.querySelector('.klb-fs__track');
        this.seq = 0;
        const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        this.threshold = (parseInt(this.dataset.threshold, 10) || 10000) * rate;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => this.onUpdate(e));
        }
        if (rate !== 1) this.refresh();
      }

      disconnectedCallback() {
        this.unsub && this.unsub();
      }

      onUpdate(e) {
        const c = e && e.cartData;
        // Full cart payloads (cart/change) carry totals; add-to-cart payloads don't, so fetch the cart.
        if (c && typeof c.total_price === 'number' && typeof c.item_count === 'number') {
          this.seq++;
          this.render(c.total_price, c.item_count);
        } else {
          this.refresh();
        }
      }

      refresh() {
        const id = ++this.seq;
        const url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => {
            if (id === this.seq) this.render(c.total_price, c.item_count);
          })
          .catch(() => {});
      }

      money(cents) {
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        const whole = cents % 100 === 0;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(whole ? 0 : 2);
        }
      }

      render(total, count) {
        this.hidden = !count;
        const remaining = Math.max(0, Math.round(this.threshold - total));
        const pct = Math.max(0, Math.min(100, Math.floor((total * 100) / this.threshold)));
        const unlocked = remaining <= 0;
        this.classList.toggle('is-unlocked', unlocked);
        const html = unlocked
          ? 'You’ve unlocked free shipping!'
          : 'You’re <strong>' + this.money(remaining) + '</strong> away from free shipping';
        if (this.text && this.text.innerHTML !== html) this.text.innerHTML = html;
        if (this.fill) this.fill.style.width = pct + '%';
        if (this.track) this.track.setAttribute('aria-valuenow', pct);
      }
    }
  );
}
